import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils/types";

export const CheckMarkIcon = ({ className, ...props }: IconProps) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(className)}
    {...props}
  >
    <path
      d="M8.33335 2.91797L4.04465 7.20667C3.88193 7.36939 3.61811 7.36939 3.45539 7.20667L1.66669 5.41797"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
